var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationServiceMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 466,
    viewBox: "0 0 514 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.955 0H417.68C422.436 0 427.011 1.8828 430.373 5.26881C433.736 8.63963 435.629 13.21 435.629 17.9929V37.8534H85.0205V17.9929C85.0205 13.21 86.8987 8.63963 90.2765 5.26881C93.6392 1.89798 98.1984 0 102.97 0L102.955 0Z",
    fill: "#25509F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_285_5445",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 36,
    width: 354,
    height: 355
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M436.477 36.2894H83.0513V390.575H436.477V36.2894Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_285_5445)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_285_5445",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 37,
    width: 351,
    height: 353
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0205 37.8534H435.629V356.517C435.629 360.83 434.781 365.112 433.13 369.105C431.479 373.098 429.071 376.727 426.026 379.779C422.982 382.831 419.361 385.245 415.378 386.9C411.394 388.555 407.123 389.406 402.821 389.406H117.829C113.527 389.406 109.256 388.555 105.272 386.9C101.304 385.245 97.6834 382.831 94.6389 379.779C91.5792 376.727 89.1708 373.098 87.5198 369.105C85.8687 365.127 85.0205 360.845 85.0205 356.517V37.8534Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_285_5445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0205 37.8534V389.421H435.629V37.8534H85.0205Z",
    fill: "#DCF9FE"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.634 23.5047C114.148 23.5047 116.193 21.4549 116.193 18.9191C116.193 16.3834 114.148 14.3336 111.634 14.3336C109.12 14.3336 107.06 16.3834 107.06 18.9191C107.06 21.4549 109.104 23.5047 111.634 23.5047Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.068 23.5047C132.597 23.5047 134.642 21.4549 134.642 18.9191C134.642 16.3834 132.597 14.3336 130.068 14.3336C127.538 14.3336 125.508 16.3834 125.508 18.9191C125.508 21.4549 127.553 23.5047 130.068 23.5047Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.396 23.5047C149.926 23.5047 151.971 21.4549 151.971 18.9191C151.971 16.3834 149.926 14.3336 147.396 14.3336C144.867 14.3336 142.822 16.3834 142.822 18.9191C142.822 21.4549 144.867 23.5047 147.396 23.5047Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M506.002 10.644C487.644 24.1728 454.063 58.2454 380.767 69.5726C375.147 70.4381 373.057 74.4314 373.057 78.8651V172.049C373.087 173.339 373.556 174.584 374.405 175.571C375.253 176.558 376.389 177.211 377.661 177.454C396.156 180.567 467.347 162.361 509.925 125.692C514 122.185 514 116.309 514 115.094V15.2902C514 11.1602 509.153 8.33602 506.017 10.644H506.002Z",
    fill: "url(#paint0_linear_285_5445)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M382.736 86.1685V143.807C382.736 144.308 382.857 144.809 383.069 145.249C383.296 145.705 383.599 146.099 383.993 146.418C384.387 146.737 384.841 146.95 385.326 147.071C385.811 147.193 386.326 147.193 386.81 147.071C397.277 144.718 425.602 137.915 443.491 129.458C444.066 129.184 444.551 128.759 444.884 128.228C445.217 127.696 445.399 127.074 445.399 126.436V70.3166C445.399 69.7548 445.263 69.2082 444.99 68.7071C444.718 68.206 444.339 67.7961 443.869 67.4924C443.4 67.1887 442.855 67.0065 442.309 66.9761C441.749 66.9306 441.188 67.0369 440.673 67.2798C430.707 71.8805 406.759 81.9322 385.917 82.8433C385.068 82.8888 384.251 83.2532 383.675 83.8758C383.084 84.4983 382.751 85.3334 382.751 86.1837L382.736 86.1685Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M385.341 134.529V140.588C385.341 141.043 385.447 141.499 385.644 141.909C385.841 142.319 386.144 142.683 386.507 142.956C386.871 143.23 387.295 143.427 387.749 143.503C388.204 143.594 388.658 143.579 389.097 143.457L420.421 134.863C420.921 134.727 421.376 134.468 421.739 134.104C422.103 133.755 422.36 133.299 422.512 132.798C422.648 132.312 422.663 131.781 422.542 131.295C422.421 130.809 422.178 130.338 421.83 129.959L405.032 111.844C404.729 111.526 404.366 111.267 403.957 111.1C403.548 110.933 403.108 110.858 402.669 110.888C402.23 110.918 401.791 111.04 401.412 111.267C401.018 111.48 400.685 111.784 400.427 112.148L385.901 132.798C385.553 133.299 385.356 133.907 385.356 134.514L385.341 134.529Z",
    fill: "#00A183"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M417.271 120.317L426.662 130.308C426.965 130.627 427.359 130.855 427.783 130.961C428.222 131.052 428.661 131.022 429.07 130.855C431.842 129.777 438.083 127.317 441.249 125.95C441.642 125.783 441.976 125.495 442.218 125.13C442.46 124.781 442.582 124.341 442.582 123.916V114.547C442.582 114.076 442.43 113.606 442.142 113.211L428.934 95.461C428.692 95.1422 428.374 94.884 428.01 94.7474C427.647 94.5955 427.238 94.5348 426.844 94.5955C426.45 94.6563 426.071 94.8233 425.768 95.0662C425.465 95.3244 425.238 95.6432 425.087 96.0228L416.801 118.024C416.665 118.419 416.619 118.844 416.71 119.239C416.786 119.649 416.983 120.029 417.271 120.332V120.317Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M409.016 104.693C411.803 104.693 414.06 102.431 414.06 99.6367C414.06 96.8428 411.803 94.5804 409.016 94.5804C406.229 94.5804 403.972 96.8428 403.972 99.6367C403.972 102.431 406.229 104.693 409.016 104.693Z",
    fill: "#FEBB94"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M459.94 68.0996C458.956 68.0996 458.001 67.553 457.532 66.6116C456.85 65.2754 457.38 63.6356 458.713 62.9675C471.528 56.4536 483.963 48.9527 495.687 40.6927C496.914 39.8272 498.595 40.1309 499.459 41.3456C500.322 42.5755 500.019 44.2609 498.807 45.1264C486.872 53.5383 474.224 61.1606 461.182 67.7959C460.788 67.9933 460.364 68.0844 459.955 68.0844L459.94 68.0996Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M459.94 89.9644C458.941 89.9644 457.971 89.4026 457.502 88.446C456.85 87.0947 457.411 85.47 458.744 84.8171C458.835 84.7715 467.272 80.6263 478.662 73.7025C479.935 72.9281 481.601 73.3381 482.373 74.6135C483.146 75.889 482.737 77.5592 481.464 78.3336C469.847 85.4093 461.455 89.5241 461.107 89.6911C460.728 89.8733 460.319 89.9644 459.925 89.9644H459.94Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M459.94 111.328C458.956 111.328 458.001 110.782 457.532 109.84C456.85 108.504 457.38 106.864 458.713 106.196C471.528 99.6822 483.963 92.1814 495.687 83.9214C496.914 83.0559 498.595 83.3596 499.459 84.5743C500.322 85.8042 500.019 87.4896 498.807 88.355C486.872 96.7669 474.224 104.389 461.182 111.025C460.788 111.222 460.364 111.313 459.955 111.313L459.94 111.328Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M459.94 135.334C458.956 135.334 458.001 134.787 457.532 133.846C456.85 132.51 457.38 130.87 458.713 130.202C471.528 123.688 483.963 116.187 495.687 107.927C496.914 107.061 498.595 107.365 499.459 108.58C500.322 109.81 500.019 111.495 498.807 112.361C486.872 120.773 474.224 128.395 461.182 135.03C460.788 135.228 460.364 135.319 459.955 135.319L459.94 135.334Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M389.946 163.697C392.49 163.697 394.55 161.632 394.55 159.066C394.55 156.5 392.49 154.45 389.946 154.45C387.401 154.45 385.341 156.515 385.341 159.066C385.341 161.617 387.401 163.697 389.946 163.697Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M416.665 156.227C419.21 156.227 421.285 154.162 421.285 151.611C421.285 149.06 419.225 146.98 416.665 146.98C414.105 146.98 412.061 149.045 412.061 151.611C412.061 154.177 414.121 156.227 416.665 156.227Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M440.779 147.967C443.324 147.967 445.399 145.902 445.399 143.336C445.399 140.77 443.339 138.72 440.779 138.72C438.219 138.72 436.174 140.785 436.174 143.336C436.174 145.887 438.234 147.967 440.779 147.967Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M490.31 241.637C464.696 263.547 397.171 313.472 311.393 315.856C309.636 315.916 307.97 316.645 306.758 317.906C305.546 319.166 304.85 320.851 304.85 322.613V458.888C304.85 460.634 305.516 462.289 306.713 463.564C307.909 464.825 309.545 465.569 311.272 465.66C337.067 466.935 434.842 466.783 499.656 397.226C500.807 395.981 501.443 394.326 501.443 392.625V246.784C501.443 245.494 501.08 244.218 500.383 243.125C499.686 242.047 498.702 241.166 497.52 240.62C496.339 240.088 495.036 239.891 493.764 240.058C492.491 240.225 491.28 240.771 490.295 241.607L490.31 241.637Z",
    fill: "#FFC38F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M432.767 316.752C431.721 316.752 430.737 316.144 430.282 315.127C429.677 313.76 430.282 312.151 431.661 311.543C458.486 299.67 478.495 280.356 478.692 280.158C479.768 279.111 481.479 279.141 482.525 280.219C483.57 281.297 483.539 283.013 482.464 284.061C481.631 284.881 461.591 304.24 433.842 316.524C433.494 316.676 433.115 316.752 432.751 316.752H432.767Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M415.878 344.781C414.681 344.781 413.59 343.976 413.257 342.761C412.878 341.319 413.727 339.831 415.181 339.436C450.655 329.961 478.465 304.255 478.738 304.012C479.828 302.995 481.54 303.056 482.555 304.149C483.57 305.242 483.509 306.958 482.419 307.975C481.252 309.068 453.382 334.851 416.559 344.675C416.332 344.735 416.09 344.766 415.862 344.766L415.878 344.781Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M426.662 426.819C414.453 426.819 405.668 409.768 397.792 394.508C390.93 381.207 383.856 367.481 376.692 368.316C370.012 369.121 366.649 374.45 361.984 381.814C359.258 386.142 356.152 391.031 351.851 395.617C342.778 405.258 323.844 409.328 323.041 409.495C321.572 409.798 320.148 408.857 319.83 407.399C319.527 405.926 320.466 404.499 321.92 404.18C322.102 404.135 339.99 400.278 347.897 391.881C351.851 387.675 354.668 383.211 357.394 378.899C362.226 371.246 366.801 364.019 376.025 362.911C386.901 361.635 394.505 376.379 402.563 392.003C410.879 408.143 419.497 424.83 430.04 420.67C442.248 415.857 446.111 397.348 449.504 381.025C452.366 367.253 454.851 355.364 461.909 350.976C468.21 347.059 473.285 350.885 477.374 353.967C481.419 357.019 485.251 359.904 490.916 357.961C492.34 357.475 493.869 358.234 494.354 359.646C494.839 361.058 494.081 362.607 492.673 363.093C484.296 365.962 478.662 361.711 474.133 358.295C469.634 354.909 467.665 353.8 464.772 355.577C459.698 358.735 457.32 370.092 454.82 382.118C451.14 399.792 446.974 419.82 432.039 425.711C430.161 426.455 428.358 426.789 426.632 426.789L426.662 426.819Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M137.535 336.763C151.592 340.787 184.461 347.969 227.524 343.019C228.221 342.913 228.918 342.973 229.584 343.171C230.25 343.383 230.871 343.717 231.402 344.188C231.917 344.659 232.326 345.236 232.613 345.874C232.886 346.511 233.037 347.21 233.022 347.908V414.565C232.992 416.038 232.432 417.45 231.462 418.559C230.493 419.652 229.175 420.381 227.721 420.609C212.392 422.719 166.845 427.214 132.915 412.516C132.052 412.136 131.31 411.498 130.795 410.694C130.28 409.889 130.022 408.947 130.053 407.991V342.655C130.053 338.798 133.93 335.731 137.52 336.763H137.535Z",
    fill: "url(#paint1_linear_285_5445)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9713 220.804C64.3295 234.333 112.739 269.605 174.237 264.002C174.842 263.926 175.448 263.987 176.024 264.169C176.599 264.351 177.114 264.655 177.569 265.065C178.023 265.475 178.372 265.976 178.599 266.523C178.841 267.084 178.947 267.677 178.932 268.284V365.977C178.902 367.268 178.432 368.513 177.584 369.5C176.751 370.487 175.6 371.155 174.327 371.383C155.848 374.51 78.9464 372.962 39.2763 333.15C38.8673 332.724 38.5492 332.239 38.322 331.707C38.0948 331.176 37.9888 330.599 37.9888 330.006V225.45C37.9888 221.32 42.8207 218.496 45.9713 220.804Z",
    fill: "#88D7F6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8412 319.651C65.5867 316.022 57.3013 304.756 57.3013 294.491C57.3013 284.227 65.6018 278.837 75.8412 282.45V270.516C59.2855 264.67 45.8652 273.371 45.8652 289.967C45.8652 306.562 59.2855 324.753 75.8412 330.614C91.6851 336.217 104.666 328.458 105.726 313.213L94.3207 309.174C93.5179 318.421 85.5505 323.083 75.8412 319.651Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6431 268.041V279.976C89.8976 283.604 98.1982 294.871 98.1982 305.135C98.1982 305.667 98.1679 306.183 98.1225 306.699L109.543 310.738C109.589 310.07 109.619 309.387 109.619 308.688C109.619 292.092 96.1988 273.902 79.6431 268.041Z",
    fill: "#00A183"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M145.094 302.949C144.927 302.949 144.76 302.934 144.579 302.903L123.403 298.864C121.934 298.591 120.964 297.164 121.252 295.691C121.525 294.218 122.949 293.246 124.418 293.535L145.594 297.574C147.063 297.847 148.032 299.274 147.744 300.747C147.502 302.053 146.366 302.949 145.094 302.949Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.094 336.232C144.927 336.232 144.76 336.217 144.579 336.186L123.403 332.147C121.934 331.874 120.964 330.447 121.252 328.974C121.525 327.501 122.949 326.529 124.418 326.818L145.594 330.857C147.063 331.13 148.032 332.557 147.744 334.03C147.502 335.336 146.366 336.232 145.094 336.232Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M154.349 321.701C154.182 321.701 154.015 321.686 153.834 321.655L123.403 315.855C121.934 315.582 120.964 314.154 121.252 312.682C121.525 311.209 122.949 310.252 124.418 310.525L154.848 316.326C156.318 316.599 157.287 318.026 156.999 319.499C156.757 320.805 155.621 321.701 154.349 321.701Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2392 18.3574C28.5974 34.0575 77.0074 69.8611 138.504 71.5617C139.762 71.6072 140.943 72.1387 141.822 73.0345C142.7 73.9455 143.185 75.1602 143.185 76.4205V174.114C143.185 175.359 142.715 176.558 141.852 177.469C140.989 178.365 139.822 178.912 138.58 178.972C120.086 179.883 49.9851 179.792 3.52907 129.913C2.69598 129.017 2.24157 127.848 2.25671 126.618V22.0622C2.25671 21.136 2.51421 20.225 3.01407 19.4506C3.51392 18.6762 4.22583 18.0537 5.05892 17.6589C5.89201 17.2641 6.83112 17.1275 7.75509 17.2489C8.66392 17.3704 9.5273 17.75 10.2392 18.3574Z",
    fill: "#F6A281"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1924 126.846V86.0319L28.4609 96.2658V138.052L14.1924 126.831V126.846Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2764 143.336V114.259L52.5449 122.807V151.55L38.2764 143.321V143.336Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.289 166.096V137.019L85.0205 135.061V163.804L99.289 166.096Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.721 167.342V116.43H108.453V167.008L122.721 167.342Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6484 156.075V142.774L75.917 146.798V161.253L61.6484 156.075Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M217.376 292.776C206.091 303.905 201.653 358.704 202.259 389.421H336.522C336.522 389.421 336.28 322.445 326.101 299.882C316.74 279.125 301.184 309.736 217.391 292.791L217.376 292.776Z",
    fill: "#1F2D49"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M239.566 162.24C239.566 162.24 256.834 181.675 251.093 187.916C239.717 200.731 209.454 224.813 199.532 232.784C199.108 233.118 198.623 233.361 198.093 233.498C197.578 233.634 197.033 233.665 196.488 233.589C195.942 233.513 195.443 233.331 194.973 233.073C194.503 232.799 194.11 232.435 193.776 232.01L170.329 201.095C169.405 199.911 168.981 198.408 169.132 196.905C169.284 195.401 169.996 194.02 171.132 193.048L216.542 153.782L239.551 162.24H239.566Z",
    fill: "#00A183"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M212.286 186.959C212.286 186.959 190.762 199.789 188.823 225.572L193.11 231.099C193.11 231.099 195.806 235.806 199.532 232.814C203.258 229.823 220.511 215.96 220.511 215.96L212.286 186.974V186.959Z",
    fill: "#007F77"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M232.416 196.722C245.837 196.722 256.728 185.805 256.728 172.352C256.728 158.899 245.837 147.967 232.416 147.967C218.996 147.967 208.105 158.884 208.105 172.352C208.105 185.82 218.996 196.722 232.416 196.722Z",
    fill: "#00A183"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M169.102 248.773L147.851 220.561L167.966 204.906L171.116 202.356L193.155 231.251L189.308 234.014L169.087 248.758L169.102 248.773Z",
    fill: "#FFCCB3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M189.323 234.029C183.628 226.392 172.934 211.466 167.981 204.906L171.132 202.356L193.125 231.083L189.338 234.029H189.323Z",
    fill: "#FF967C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M158.166 252.675C167.905 252.675 175.812 244.749 175.812 234.986C175.812 225.223 167.905 217.281 158.166 217.281C148.426 217.281 140.52 225.207 140.52 234.986C140.52 244.764 148.411 252.675 158.166 252.675Z",
    fill: "#FFCCB3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M173.1 225.465C173.1 225.465 116.163 141.635 113.542 134.499C110.982 127.545 97.5317 144.277 97.5317 144.277L141.595 240.664L173.1 225.45V225.465Z",
    fill: "#FFCCB3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M251.487 108.55L244.64 156.394C244.64 156.394 242.838 162.741 250.82 163.713C258.788 164.669 275.798 162.528 281.857 156.03C287.931 149.546 285.81 146.327 285.81 146.327L272.92 94.3982L251.472 108.55H251.487Z",
    fill: "#FFCCB3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M250.532 114.745L267.27 108.808L246.533 139.631L250.532 114.729V114.745Z",
    fill: "#FF967C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M232.537 49.4539C232.537 49.4539 218.178 83.2988 225.661 106.485C230.538 121.608 241.171 124.326 265.528 112.998C287.854 102.613 293.656 94.7323 293.656 94.7323L296.943 57.0155C296.943 57.0155 247.124 19.2988 232.537 49.4539Z",
    fill: "#FFCCB3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M244.519 142.637C244.519 142.637 226.115 147.769 222.389 150.761C218.648 153.752 212.74 169.072 212.74 186.61C212.74 211.481 216.149 224.828 216.149 240.27C216.149 255.712 208.045 314.595 208.045 314.595H327.404C324.344 255.605 327.404 150.244 327.404 150.244L281.917 139.737C271.663 141.514 244.519 142.652 244.519 142.652V142.637Z",
    fill: "#00A183"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M305.35 172.352C305.35 172.352 289.491 182.859 294.156 193.473C299.412 205.392 294.156 218.542 294.156 236.869C292.338 242.365 291.293 247.604 291.293 252.037C291.293 256.471 288.854 252.235 288.854 265.156C288.854 274.358 317.679 282.329 316.937 274.889C311.923 225.177 332.751 193.701 305.35 172.337V172.352Z",
    fill: "#007F77"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M360.273 267.464L325.147 270.349L319.148 244.81L311.923 225.177L348.912 220.728L353.532 242.699L360.288 267.449L360.273 267.464Z",
    fill: "#FFCCB3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M350.155 226.68L351.442 232.845L315.028 233.634L312.635 227.12L350.155 226.68Z",
    fill: "#FF967C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M321.345 198.226C334.765 198.226 345.656 187.308 345.656 173.855C345.656 160.402 334.765 149.47 321.345 149.47C307.924 149.47 297.034 160.387 297.034 173.855C297.034 187.324 307.909 198.226 321.345 198.226Z",
    fill: "#00A183"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M316.664 162.392C316.664 162.392 342.293 158.17 344.459 166.385C349.155 182.875 354.941 209.371 356.334 222.034C356.38 222.58 356.319 223.112 356.168 223.628C356.001 224.144 355.744 224.63 355.395 225.04C355.047 225.45 354.623 225.784 354.138 226.042C353.653 226.285 353.138 226.437 352.593 226.483L313.998 229.793C312.514 229.929 311.014 229.489 309.848 228.563C308.666 227.637 307.879 226.285 307.667 224.797L297.215 177.348L316.664 162.407V162.392Z",
    fill: "#00A183"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M241.49 46.2349C241.49 46.2349 242.398 62.679 256.288 70.6354C256.288 70.6354 260.348 83.238 275.51 86.214C275.51 86.214 274.616 74.6287 281.841 74.7502C294.095 74.9628 288.067 93.6238 279.781 96.6757C274.147 98.7559 270.754 106.135 279.115 122.959C298.321 116.081 311.832 88.3398 306.531 57.5621C302.29 32.9186 271.814 24.856 265.558 25.6607C265.558 25.6607 239.551 16.6567 225.858 41.3609C214.149 62.4816 225.085 75.0843 225.085 75.0843L231.311 56.2866C231.311 56.2866 233.916 58.1239 241.49 46.2349Z",
    fill: "#080B09"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M360.409 328.382H267.345C265.543 328.382 263.816 327.729 262.468 326.529C261.12 325.33 260.256 323.675 260.029 321.898L251.441 253.146C251.304 252.113 251.395 251.05 251.713 250.048C252.016 249.046 252.546 248.12 253.243 247.33C253.94 246.541 254.788 245.918 255.743 245.478C256.697 245.053 257.727 244.825 258.787 244.825H369.027C370.072 244.825 371.118 245.053 372.072 245.478C373.026 245.918 373.874 246.541 374.571 247.33C375.268 248.12 375.783 249.046 376.086 250.048C376.404 251.05 376.495 252.113 376.358 253.146L367.77 321.898C367.543 323.69 366.68 325.345 365.331 326.529C363.983 327.729 362.241 328.382 360.454 328.382H360.409Z",
    fill: "url(#paint2_linear_285_5445)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M314.089 291.864C317.71 291.864 320.618 288.934 320.618 285.32C320.618 281.706 317.694 278.776 314.089 278.776C310.484 278.776 307.561 281.706 307.561 285.32C307.561 288.934 310.484 291.864 314.089 291.864Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9409 149.789L94.3365 139.009C94.3365 139.009 74.509 127.636 72.2066 123.521C69.9043 119.406 69.0106 107.669 73.07 104.663C73.07 104.663 57.2413 92.7432 59.9375 90.329C62.6185 87.7477 93.7003 110.888 93.7003 110.888C93.7003 110.888 89.9135 93.8365 95.6694 93.0317C97.2296 99.6367 99.8954 105.953 103.561 111.662C109.605 121.046 110.362 129.458 110.362 129.458L117.496 143.199L99.9257 149.804L99.9409 149.789Z",
    fill: "#FFCCB3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M74.145 104.966L83.718 111.025",
    stroke: "#FF967C",
    strokeWidth: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7212 111.89L80.84 116.961",
    stroke: "#FF967C",
    strokeWidth: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2964 119.376L79.719 122.807",
    stroke: "#FF967C",
    strokeWidth: 0.99,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M341.46 325.573C341.46 325.573 346.367 325.983 345.64 328.473C344.898 330.963 340.506 329.809 336.492 332.299C332.478 334.789 316.634 336.566 308.712 335.245C300.805 333.909 298.594 325.573 298.594 325.573C298.594 325.573 297.261 317.662 311.257 316.842C325.253 316.022 331.751 320.532 334.189 325.406L341.46 325.573Z",
    fill: "#FFCCB3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M304.547 318.072L307.561 326.21",
    stroke: "#E56441",
    strokeWidth: 0.77,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M312.362 316.736L315.377 324.874",
    stroke: "#E56441",
    strokeWidth: 0.77,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M320.633 317.434L323.647 325.588",
    stroke: "#E56441",
    strokeWidth: 0.77,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M467.453 185.638H389.295C387.75 185.638 386.235 185.942 384.826 186.534C383.402 187.126 382.115 187.976 381.039 189.07C379.949 190.148 379.085 191.438 378.51 192.866C377.919 194.293 377.616 195.811 377.616 197.345V221.594C377.616 223.142 377.919 224.661 378.51 226.073C379.101 227.5 379.949 228.791 381.039 229.869C382.115 230.962 383.402 231.828 384.826 232.405C386.25 232.997 387.765 233.3 389.295 233.3H417.044L425.239 241.515C426.011 242.289 427.041 242.714 428.132 242.714C429.222 242.714 430.267 242.274 431.025 241.515L439.219 233.3H467.484C470.589 233.3 473.558 232.07 475.739 229.869C477.935 227.682 479.162 224.691 479.162 221.594V197.345C479.162 194.232 477.935 191.256 475.739 189.07C473.558 186.868 470.574 185.638 467.484 185.638H467.453Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M410.773 201.778C409.728 200.807 408.365 200.275 406.941 200.275C405.517 200.275 404.154 200.807 403.109 201.778L401.67 203.115L400.231 201.778C399.185 200.807 397.822 200.275 396.398 200.275C394.975 200.275 393.611 200.807 392.566 201.778C392.021 202.28 391.566 202.887 391.279 203.57C390.991 204.253 390.824 204.982 390.824 205.726C390.824 206.47 390.976 207.214 391.279 207.898C391.582 208.581 392.021 209.188 392.566 209.689L401.67 218.162L410.788 209.796C411.364 209.294 411.818 208.687 412.136 207.989C412.454 207.305 412.621 206.546 412.621 205.787C412.621 205.028 412.454 204.284 412.136 203.585C411.818 202.902 411.349 202.28 410.788 201.778H410.773Z",
    fill: "#F4608A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M420.952 206.728C421.028 205.696 421.421 204.906 422.133 204.314C422.845 203.737 423.769 203.449 424.905 203.449C425.663 203.449 426.314 203.585 426.859 203.874C427.42 204.147 427.844 204.512 428.116 204.982C428.404 205.453 428.556 205.984 428.556 206.577C428.556 207.26 428.359 207.852 427.95 208.368C427.556 208.869 427.041 209.188 426.405 209.34V209.416C427.117 209.598 427.692 209.947 428.131 210.464C428.556 210.995 428.768 211.678 428.768 212.514C428.768 213.151 428.616 213.728 428.328 214.244C428.041 214.746 427.617 215.14 427.026 215.429C426.45 215.717 425.753 215.869 424.935 215.869C423.754 215.869 422.785 215.565 422.027 214.958C421.27 214.336 420.846 213.455 420.755 212.316H422.224C422.3 212.984 422.573 213.531 423.042 213.956C423.512 214.381 424.133 214.594 424.905 214.594C425.678 214.594 426.284 214.381 426.677 213.986C427.086 213.576 427.298 213.045 427.298 212.407C427.298 211.572 427.011 210.965 426.465 210.6C425.905 210.236 425.057 210.054 423.936 210.054H423.557V208.793H423.966C424.981 208.778 425.753 208.611 426.284 208.292C426.799 207.958 427.071 207.442 427.071 206.759C427.071 206.167 426.874 205.696 426.48 205.332C426.102 204.982 425.557 204.8 424.845 204.8C424.133 204.8 423.603 204.982 423.178 205.332C422.754 205.681 422.512 206.167 422.436 206.774H420.952V206.728ZM432.615 213.667L430.752 218.162H429.737L430.949 213.667H432.615ZM441.794 205.013H435.947V208.824C436.205 208.475 436.584 208.171 437.068 207.958C437.568 207.715 438.113 207.609 438.689 207.609C439.613 207.609 440.355 207.806 440.931 208.201C441.506 208.581 441.915 209.067 442.173 209.689C442.43 210.297 442.552 210.934 442.552 211.618C442.552 212.422 442.4 213.151 442.097 213.774C441.794 214.396 441.325 214.913 440.719 215.277C440.098 215.641 439.34 215.824 438.432 215.824C437.265 215.824 436.311 215.52 435.584 214.928C434.872 214.32 434.418 213.516 434.281 212.514H435.766C435.902 213.151 436.22 213.652 436.674 214.002C437.129 214.351 437.735 214.533 438.447 214.533C439.325 214.533 439.992 214.275 440.431 213.743C440.87 213.212 441.097 212.498 441.097 211.633C441.097 210.767 440.87 210.099 440.431 209.629C439.976 209.143 439.325 208.915 438.462 208.915C437.871 208.915 437.356 209.052 436.902 209.355C436.462 209.629 436.159 210.008 435.947 210.509H434.508V203.692H441.764V205.028L441.794 205.013ZM444.399 214.563C445.808 213.425 446.914 212.498 447.717 211.769C448.519 211.041 449.186 210.281 449.731 209.477C450.292 208.672 450.564 207.882 450.564 207.108C450.564 206.394 450.382 205.817 450.034 205.407C449.701 204.982 449.125 204.77 448.353 204.77C447.58 204.77 447.005 205.013 446.581 205.483C446.172 205.954 445.944 206.577 445.914 207.366H444.445C444.49 206.121 444.869 205.149 445.566 204.466C446.278 203.783 447.202 203.449 448.323 203.449C449.443 203.449 450.367 203.768 451.034 204.405C451.715 205.043 452.049 205.909 452.049 207.032C452.049 207.958 451.776 208.854 451.216 209.75C450.67 210.616 450.034 211.39 449.353 212.058C448.656 212.726 447.747 213.485 446.656 214.366H452.397V215.641H444.384V214.563H444.399ZM461.591 204.876L456.956 215.778H455.411L460.122 205.028H453.685V203.722H461.591V204.876Z",
    fill: "#00A183"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80044 408.841H67.7376C68.9039 408.841 70.04 408.613 71.1003 408.173C72.1757 407.733 73.1451 407.08 73.9631 406.26C74.781 405.44 75.4323 404.468 75.8716 403.39C76.3108 402.312 76.5381 401.173 76.5381 400.019V381.738C76.5381 380.569 76.3108 379.43 75.8716 378.367C75.4323 377.289 74.781 376.317 73.9631 375.497C73.1451 374.677 72.1757 374.04 71.1003 373.584C70.04 373.144 68.8888 372.916 67.7376 372.916H46.8195L40.6395 366.736C40.064 366.144 39.2763 365.825 38.4584 365.825C37.6404 365.825 36.8528 366.144 36.2772 366.736L30.0972 372.916H8.80044C6.46779 372.916 4.22603 373.842 2.575 375.497C0.92397 377.152 0 379.4 0 381.738V400.019C0 402.358 0.92397 404.605 2.575 406.26C4.22603 407.915 6.46779 408.841 8.80044 408.841Z",
    fill: "#00A183"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5801 395.373C37.6404 394.523 38.4735 393.809 39.0793 393.263C39.6852 392.716 40.1851 392.139 40.6092 391.532C41.0333 390.924 41.2454 390.332 41.2454 389.755C41.2454 389.178 41.109 388.768 40.8364 388.464C40.5789 388.146 40.1548 387.979 39.564 387.979C38.9733 387.979 38.5492 388.161 38.2311 388.525C37.913 388.874 37.7464 389.36 37.7313 389.952H36.6255C36.6558 389.011 36.9436 388.282 37.4738 387.766C38.0039 387.25 38.7007 386.992 39.5489 386.992C40.3971 386.992 41.0939 387.235 41.5938 387.705C42.1088 388.176 42.3663 388.844 42.3663 389.679C42.3663 390.378 42.1542 391.061 41.7301 391.714C41.3211 392.367 40.8515 392.959 40.3214 393.46C39.7913 393.961 39.1096 394.538 38.2917 395.206H42.6238V396.163H36.5801V395.343V395.373ZM43.6689 394.265V393.399L48.0918 387.265H49.4551V393.263H50.7123V394.265H49.4551V396.284H48.3342V394.265H43.684H43.6689ZM48.3645 388.449L44.9867 393.263H48.3645V388.449ZM51.8332 389.467C51.8938 388.692 52.1815 388.085 52.7268 387.644C53.257 387.204 53.9537 386.992 54.8171 386.992C55.3927 386.992 55.8774 387.098 56.2864 387.31C56.7105 387.523 57.0135 387.796 57.2255 388.146C57.4527 388.495 57.5587 388.89 57.5587 389.345C57.5587 389.861 57.4073 390.317 57.1043 390.696C56.8165 391.061 56.4227 391.319 55.9532 391.425V391.486C56.4985 391.623 56.9377 391.881 57.2407 392.291C57.5587 392.686 57.7254 393.202 57.7254 393.84C57.7254 394.31 57.6193 394.751 57.3921 395.13C57.1649 395.51 56.8468 395.798 56.4076 396.026C55.9683 396.254 55.4382 396.345 54.8323 396.345C53.9386 396.345 53.2115 396.117 52.636 395.662C52.0604 395.191 51.7574 394.523 51.6817 393.672H52.7874C52.848 394.174 53.0601 394.584 53.4085 394.902C53.7568 395.221 54.2415 395.388 54.8171 395.388C55.3927 395.388 55.8471 395.236 56.1501 394.933C56.453 394.629 56.6196 394.219 56.6196 393.733C56.6196 393.095 56.4076 392.655 55.9835 392.367C55.5593 392.078 54.9383 391.942 54.0901 391.942H53.8023V390.985H54.1052C54.8777 390.985 55.4685 390.848 55.8623 390.605C56.2561 390.347 56.453 389.968 56.453 389.436C56.453 388.996 56.3015 388.631 56.0137 388.373C55.726 388.1 55.317 387.963 54.7868 387.963C54.2567 387.963 53.8477 388.1 53.5296 388.373C53.2115 388.647 53.0298 388.996 52.954 389.451H51.8483L51.8332 389.467ZM64.3295 389.345C64.1326 388.419 63.5721 387.948 62.6027 387.948C61.8605 387.948 61.3001 388.237 60.9365 388.814C60.573 389.391 60.3912 390.332 60.4064 391.653C60.6033 391.213 60.9214 390.863 61.3607 390.636C61.8151 390.378 62.3149 390.256 62.8602 390.256C63.7236 390.256 64.4204 390.529 64.9202 391.061C65.4352 391.592 65.7079 392.336 65.7079 393.293C65.7079 393.87 65.5867 394.371 65.3746 394.842C65.1474 395.297 64.8142 395.662 64.3598 395.92C63.9205 396.193 63.3752 396.33 62.739 396.33C61.8757 396.33 61.194 396.132 60.7245 395.738C60.2398 395.343 59.8914 394.826 59.7096 394.143C59.5127 393.46 59.4218 392.61 59.4218 391.623C59.4218 388.54 60.4973 386.992 62.6482 386.992C63.4661 386.992 64.1174 387.219 64.587 387.66C65.0565 388.115 65.3292 388.677 65.4201 389.345H64.3598H64.3295ZM62.6179 391.213C62.2543 391.213 61.9211 391.289 61.603 391.44C61.2849 391.577 61.0274 391.805 60.8154 392.109C60.6185 392.397 60.5276 392.761 60.5276 393.187C60.5276 393.824 60.7245 394.356 61.088 394.751C61.4515 395.145 61.9817 395.343 62.6633 395.343C63.254 395.343 63.7236 395.161 64.0568 394.796C64.4052 394.432 64.587 393.931 64.587 393.308C64.587 392.655 64.4204 392.139 64.0871 391.759C63.7539 391.38 63.254 391.182 62.6179 391.182V391.213Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5117 398.136H13.4353C13.7989 398.136 14.1321 398 14.3896 397.726C14.6471 397.468 14.7986 397.134 14.7986 396.77V387.872C14.7986 387.523 14.6623 387.174 14.3896 386.916C14.1321 386.657 13.7989 386.521 13.4353 386.521H11.5117C11.1481 386.521 10.8149 386.657 10.5423 386.916C10.2848 387.174 10.1484 387.523 10.1484 387.872V396.77C10.1484 397.134 10.2848 397.468 10.5423 397.726C10.7998 397.985 11.1481 398.136 11.5117 398.136Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0394 380.903C19.2669 380.903 18.8731 381.298 18.8731 383.226C18.8731 385.154 17.0857 386.551 15.9497 387.31V396.907C17.1766 397.484 19.6607 398.334 23.4929 398.334H24.735C25.4621 398.334 26.1588 398.076 26.7193 397.605C27.2797 397.134 27.6432 396.481 27.7796 395.768L28.6429 390.727C28.7187 390.286 28.7035 389.831 28.5823 389.391C28.4612 388.95 28.2643 388.54 27.9613 388.206C27.6735 387.857 27.31 387.584 26.901 387.386C26.4921 387.189 26.0376 387.098 25.5984 387.098H21.9479C22.3569 386.111 22.5538 385.063 22.5387 384C22.5387 381.677 20.7968 380.903 20.0243 380.903H20.0394Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_285_5445",
    x1: 373.057,
    y1: 93.7909,
    x2: 513.985,
    y2: 93.7909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D6E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D6E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D2E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D1E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D0E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CFE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#CFDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CDDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CADCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#C9DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C9DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C8DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C8DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#C6DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C5D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C4D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C4D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C2D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C2D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C1D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#C0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#C0D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BED5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BED4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BDD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#BCD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BBD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#BBD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#BAD2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B8D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B7D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B7D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B6CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B6CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_285_5445",
    x1: 130.068,
    y1: 379.734,
    x2: 233.022,
    y2: 379.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F1F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EFF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EDF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EDF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ECF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EBF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E8F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E6EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E5EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E4EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E2ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E0EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#DCE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DBE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D8E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D6E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D1E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#CFE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#CDDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CCDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#CADCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C9DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8DBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_285_5445",
    x1: 251.38,
    y1: 286.596,
    x2: 376.389,
    y2: 286.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F8FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F2F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F1F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F1F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EDF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ECF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#EBF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EBF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E8F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E5EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E4EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E0EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DFEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#DEEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#DCE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#DAE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#D9E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D8E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D6E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D2E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D1E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#D1E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D0E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#CFE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CFDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CDDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#CBDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationServiceMarketing);
export default __webpack_public_path__ + "static/media/illustration_service_marketing.ce85189fa761572476c23dee273e3d38.svg";
export { ForwardRef as ReactComponent };